import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/columns-editor.scss";
import grid from "components/grid.scss";

export const ColumnsEditor = ({ columns, onToggle }) => (
  <div>
    <h4 className={ styles.title }>Toggle column visibility</h4>
    <div className={ styles["selection-container"] }>
      { columns.map(column => renderColumn(column, onToggle)) }
    </div>
  </div>
);

const columnType = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  visible: PropTypes.bool
});

ColumnsEditor.propTypes = {
  columns: PropTypes.arrayOf(columnType).isRequired,
  onToggle: PropTypes.func.isRequired // (string) => void
};

const renderColumn = (column, onToggle) => (
  <div className={ `${grid["col-md-4"]} ${styles.cell}` } key={ `column-container-${column.name}` }>
    <input
      checked={ column.visible }
      id={ `column-${column.key}` }
      onChange={ () => onToggle(column.key) }
      type="checkbox"
    />
    <label htmlFor={ `column-${column.key}` }>{ column.name }</label>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/components/common/columns-editor.jsx